import React from 'react';

const DentalTeam = () => {
    return (
        <div>
            <h2>Improve our Dental team...</h2>
            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        </div>
    );
};

export default DentalTeam;